import { Heart, HandCoins, ShieldCheck, Megaphone, Coins, ArrowDownToLine, Wallet, CheckCircle2, Clock, XCircle, RotateCcw, Gift } from "lucide-react";

// « Mes transactions » — mirrors accounting_core.member_activity (types, statuses, i18n keys).
export const ACTIVITY_FILTERS = [
  { key: "all", i18n: "activity.f_all", fr: "Tout" },
  { key: "donation", i18n: "activity.f_donation", fr: "Soutiens" },
  { key: "verification", i18n: "activity.f_verification", fr: "Yalola Vérifié" },
  { key: "ad_credit", i18n: "activity.f_ad_credit", fr: "Crédits pub" },
  { key: "ad", i18n: "activity.f_ad", fr: "Campagnes" },
  { key: "withdrawal", i18n: "activity.f_withdrawal", fr: "Retraits" },
  { key: "wallet", i18n: "activity.f_wallet", fr: "Portefeuille" },
];
export const ACTIVITY_STATUS_FILTERS = [
  { key: "all", i18n: "activity.st_all", fr: "Tous statuts" },
  { key: "settled", i18n: "activity.st_settled", fr: "Réglé" },
  { key: "pending", i18n: "activity.st_pending", fr: "En cours" },
  { key: "refused", i18n: "activity.st_refused", fr: "Refusé / annulé" },
  { key: "refunded", i18n: "activity.st_refunded", fr: "Remboursé" },
];
// Legacy /history?filter=… values → new filters.
export const LEGACY_FILTER_MAP = { donation: "donation", verification: "verification", withdrawal: "withdrawal", ad: "ad", ad_credit: "ad_credit", wallet: "wallet" };

export const TYPE_META = {
  donation: { icon: Heart, color: "#D97757" },
  donation_in: { icon: HandCoins, color: "var(--yalola-secondary)" },
  verification: { icon: ShieldCheck, color: "#E0A63C" },
  ad_credit: { icon: Coins, color: "var(--yalola-accent-text)" },
  ad: { icon: Megaphone, color: "var(--yalola-accent-text)" },
  withdrawal: { icon: ArrowDownToLine, color: "#6B7280" },
  wallet: { icon: Wallet, color: "var(--yalola-secondary)" },
};
export const typeMeta = (row) => (row.type === "donation" && row.direction === "in" ? TYPE_META.donation_in : TYPE_META[row.type] || TYPE_META.wallet);

const OK = { bg: "#D1FAE5", color: "#065F46", icon: CheckCircle2 };
const WAIT = { bg: "#FEF3C7", color: "#92400E", icon: Clock };
const KO = { bg: "#FEE2E2", color: "#991B1B", icon: XCircle };
const NEUTRAL = { bg: "#F3F4F6", color: "#374151", icon: XCircle };
export const STATUS_META = {
  paid: OK, settled: OK, completed: OK,
  pending: WAIT, requested: WAIT, under_review: WAIT, approved: { ...WAIT, bg: "#DBEAFE", color: "#1E40AF" }, processing: { ...WAIT, bg: "#DBEAFE", color: "#1E40AF" },
  rejected: KO, failed: KO, cancelled: NEUTRAL, expired: NEUTRAL,
  refunded: { bg: "#EDE9FE", color: "#5B21B6", icon: RotateCcw }, free: { bg: "#F3F4F6", color: "#374151", icon: Gift },
};
export const statusMeta = (s) => STATUS_META[s] || WAIT;
export const STATUS_FR = { paid: "Payé", settled: "Réglé", completed: "Terminé", pending: "En attente", requested: "Demandé", under_review: "En vérification",
  approved: "Approuvé", processing: "En cours de paiement", rejected: "Refusé", cancelled: "Annulé", failed: "Échoué", expired: "Expiré", refunded: "Remboursé", free: "Offert" };

// Localized row label: i18n key from the backend (+ {party}) with the French backend label as fallback.
export const rowLabel = (t, row) => {
  const fr = row.label || "";
  if (!row.label_key) return fr;
  const base = t(row.label_key, fr);
  const withParty = base.includes("{party}") ? base.replace("{party}", row.party || "—") : base;
  return row.title ? `${withParty} : ${row.title}` : withParty;
};

export const downloadBlob = (data, filename, type) => {
  const url = URL.createObjectURL(type ? new Blob([data], { type }) : data);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};
